import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import { createPBlock } from "../../utils/textBlocksHelpers";
import imagePlaceholder from "./contact_item_image_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "contactItem",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "auto",
                height: "2.375rem",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
          },
        }),
        createPBlock({
          text: "hello@courseplus.com",
        }),
      ],
    },
  },
};
